import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { AuthLayout } from '../components/auth/AuthLayout';
import { Banner, Button, Field, Input, buttonClasses } from '../components/ui';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setEmailSent(false);
    setIsLoading(true);

    try {
      await api.post('/user/forgot-password', { email });
      setEmailSent(true);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Fehler beim Zurücksetzen des Passworts. Bitte versuche es erneut.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Passwort vergessen"
      description="Gib deine E-Mail-Adresse ein. Du erhältst einen Link, um ein neues Passwort zu setzen."
      footer={
        <Link to="/login" className="font-semibold text-brand hover:underline">
          Zurück zum Login
        </Link>
      }
    >
      {error && (
        <Banner tone="danger" className="mb-4">
          {error}
        </Banner>
      )}

      {emailSent ? (
        <Banner tone="success" title="E-Mail gesendet!">
          <p>
            Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen deines Passworts
            gesendet. Prüfe auch deinen Spam-Ordner.
          </p>
          <p className="mt-2">
            Der Link ist <strong>1 Stunde</strong> gültig.
          </p>
          <Link to="/login" className={buttonClasses('primary', 'md', 'mt-4 w-full')}>
            Zum Login
          </Link>
        </Banner>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Field label="E-Mail-Adresse" htmlFor="email">
            <Input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="deine@email.de"
              required
              disabled={isLoading}
              autoComplete="email"
            />
          </Field>

          <Button type="submit" fullWidth loading={isLoading} disabled={isLoading || !email}>
            Reset-Link anfordern
          </Button>
        </form>
      )}
    </AuthLayout>
  );
};

export default ForgotPassword;
